import { getBrandId } from '../helpers/getBrandId/getBrandId';

export enum QueryKeys {
  item = 'item',
  blob = 'blob',
  itemModifierGroups = 'itemModifierGroups',
  items = 'items',
  productSizes = 'productSizes',
  menu = 'menu',
  menus = 'menus',
  inventory = 'inventory',
  inventoryItem = 'inventoryItem',
  ranges = 'ranges',
  librarySyncStatus = 'librarySyncStatus',
  notifications = 'notifications',
  productPrices = 'productPrices',
  venues = 'venues',
  venueCategories = 'venueCategories',
  priceBands = 'priceBands',
  priceRules = 'priceRules',
  priceSchemes = 'priceSchemes',
  externalSystems = 'externalSystems',
  events = 'events',
  pricingCategories = 'pricingCategories',
}

export const SYNC_STATUS_QUERY = [getBrandId(), QueryKeys.librarySyncStatus];
export const NOTIFICATIONS_QUERY = [getBrandId(), QueryKeys.notifications];
export const PRICE_RULES_QUERY = [getBrandId(), QueryKeys.priceRules];
